import { render, staticRenderFns } from "./scoreChart.vue?vue&type=template&id=24c43d86&scoped=true"
import script from "./scoreChart.vue?vue&type=script&lang=js"
export * from "./scoreChart.vue?vue&type=script&lang=js"
import style0 from "./scoreChart.vue?vue&type=style&index=0&id=24c43d86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_77a37368fa9f7d737cecfb85aa182826/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c43d86",
  null
  
)

export default component.exports